import { defineMessages } from 'react-intl';

export const messages: {
	goalsChangeboardingTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	focusChangeboardingTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	goalTypesLink: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	goalsIntroductionContent: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	focusIntroductionContent: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	goalsContent: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	focusContent: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	goalsChangeboardingTitle: {
		id: 'success-measures-changeboarding.goal-page-banners-placement.goal-types-title',
		defaultMessage: 'Goal types are now available',
		description: 'Signifies that goal types are now available to users',
	},
	focusChangeboardingTitle: {
		id: 'success-measures-changeboarding.goal-page-banners-placement.focus-changeboarding-title',
		defaultMessage: `We've made changes to better support OKR structures`,
		description: 'Signifies that goal types are now available to users',
	},
	goalTypesLink: {
		id: 'success-measures-changeboarding.goal-page-banners-placement.goal-types-link',
		defaultMessage: 'More on goal types',
		description: 'Takes the user to a link where they can discover more on goal types',
	},
	goalsIntroductionContent: {
		id: 'success-measures-changeboarding.goal-page-banners-placement.goal-changeboarding-introduction',
		defaultMessage:
			'Goal types give more flexibility in how you structure your goals and allow you to better represent fragment works like OKRs. Plus, you can now measure progress with success measures, which have their own updates and allow you to track multiple metrics on a goal.',
		description: 'Change boarding introduction that lets the user know the benefits of goal types',
	},
	focusIntroductionContent: {
		id: 'success-measures-changeboarding.goal-page-banners-placement.focus-changeboarding-introduction',
		defaultMessage:
			'Objectives now have a dedicated key results section, creating a clear distinction from sub-goals. You can now track multiple metrics through an objective’s key results, plus share separate updates on each key result.',
		description: 'Change boarding introduction for focus users',
	},
	goalsContent: {
		id: 'success-measures-changeboarding.goal-page-banners-placement.goals-changeboarding-content',
		defaultMessage:
			'You can continue using your using goals as is, but you won’t be able to link metrics to any new goals you create.',
		description: 'Changeboarding banner content for goals users',
	},
	focusContent: {
		id: 'success-measures-changeboarding.goal-page-banners-placement.focus-changeboarding-content',
		defaultMessage:
			'To avoid breaks in reporting, you can continue using your existing objectives as is, but any new objectives will use the new, bundled structure.',
		description: 'Changeboarding banner content for focus users',
	},
});
